var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "收件人修改",
        visible: _vm.visible,
        width: "600px",
        center: "",
        "close-on-press-escape": false,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "editForm",
          attrs: {
            "label-width": "100px",
            model: _vm.receiveForm,
            rules: _vm.rules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "收件人姓名", prop: "name" } },
            [
              _c("el-input", {
                staticClass: "y-w-400",
                attrs: { placeholder: "请输入", maxlength: 12 },
                model: {
                  value: _vm.receiveForm.name,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.receiveForm,
                      "name",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "receiveForm.name",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { ref: "mobile", attrs: { label: "手机号码", prop: "mobile" } },
            [
              _c("el-input", {
                staticClass: "y-w-400",
                attrs: { placeholder: "请输入", maxlength: 11 },
                model: {
                  value: _vm.receiveForm.mobile,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.receiveForm,
                      "mobile",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "receiveForm.mobile",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "省市区", prop: "district" } },
            [
              _c(
                "el-select",
                {
                  staticClass: "y-w-120 y-mr-20",
                  attrs: {
                    filterable: "",
                    placeholder: "请选择省",
                    clearable: "",
                  },
                  on: { change: _vm.handleChangeProvice },
                  model: {
                    value: _vm.receiveForm.provinceId,
                    callback: function ($$v) {
                      _vm.$set(_vm.receiveForm, "provinceId", $$v)
                    },
                    expression: "receiveForm.provinceId",
                  },
                },
                _vm._l(_vm.provinceList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.name, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "y-w-120 y-mr-20",
                  attrs: {
                    filterable: "",
                    placeholder: "请选择市",
                    clearable: "",
                  },
                  on: { change: _vm.handleChangeCity },
                  model: {
                    value: _vm.receiveForm.cityId,
                    callback: function ($$v) {
                      _vm.$set(_vm.receiveForm, "cityId", $$v)
                    },
                    expression: "receiveForm.cityId",
                  },
                },
                _vm._l(_vm.cityList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.name, value: item.value },
                  })
                }),
                1
              ),
              _c(
                "el-select",
                {
                  staticClass: "y-w-120",
                  attrs: {
                    filterable: "",
                    placeholder: "请选择区",
                    clearable: "",
                  },
                  on: { change: _vm.handleChangeDistrict },
                  model: {
                    value: _vm.receiveForm.districtId,
                    callback: function ($$v) {
                      _vm.$set(_vm.receiveForm, "districtId", $$v)
                    },
                    expression: "receiveForm.districtId",
                  },
                },
                _vm._l(_vm.districtList, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.name, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "详细地址", prop: "addressDetail" } },
            [
              _c("el-input", {
                staticClass: "y-w-400",
                attrs: { placeholder: "请输入", maxlength: 64 },
                model: {
                  value: _vm.receiveForm.addressDetail,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.receiveForm,
                      "addressDetail",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "receiveForm.addressDetail",
                },
              }),
            ],
            1
          ),
          _c("div", { staticClass: "tipStyle" }, [
            _vm._v("注意：已打印的订单修改收件人信息后只能用新单号打印"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.saveInfo } },
            [_vm._v("保存")]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.visible = _vm.fasle
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }